import React, { useEffect, useState, useRef } from "react";
import { Card, Row, Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Field, ErrorMessage } from "formik";
import { TICKET_DETAILS, TICKETING } from "../../../../shared/constants/Constants";
import Modal from "react-bootstrap/Modal";
import DefaultButton from "../../../../shared/components/DefaultButton";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./Ticketing.css";
import { useNavigate } from "react-router-dom";
import { loadMessageTemplateDropdown } from "../redux/Actions";
import { useDispatch, useSelector } from "react-redux";
import StoreCallVisitForm from "../../../search-sap/components/StoreCallVisitForm";
import TicketAttachmentUpload from "./TicketAttachmentUpload ";
import Modalpopup from "../../../../shared/components/Modalpopup";


const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const getLatestSolution = (notes) => {
  if (!Array.isArray(notes) || notes.length === 0) return "";
  return notes[notes.length - 1]?.notes || "";
};

const TicketGeneral = ({ values, setFieldValue, ticketdetails, newMessageAttachments, canEdit, type, resetTemplate, onDeleteAttachment  }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showImageModal, setShowImageModal] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [attachments, setAttachments] = useState([]);
  const combinedAttachments = [...(ticketdetails?.attachments || []), ...newMessageAttachments];
  const [previewType, setPreviewType] = useState("");
  const [zoom, setZoom] = useState(1);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [addressCopied, setAddressCopied] = useState(false);
  const [empSearchValue, setEmpSearchValue] = useState("");
  const [showStoreVisitModal, setShowStoreVisitModal] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [showDeleteAttachmentModal, setShowDeleteAttachmentModal] = useState(false);
  const [pendingDeleteFileId, setPendingDeleteFileId] = useState(null);

  const handleDeleteAttachment = (fileId) => {
    setPendingDeleteFileId(fileId);
    setShowDeleteAttachmentModal(true);
  };

  const confirmDeleteAttachment = () => {
    if (pendingDeleteFileId == null) return;
    setDeletingId(pendingDeleteFileId);
    onDeleteAttachment(ticketdetails.id, pendingDeleteFileId);
    setShowDeleteAttachmentModal(false);
    setPendingDeleteFileId(null);
  };


  useEffect(() => {
    if (resetTemplate) {
      setSelectedTemplateId("");
    }
  }, [resetTemplate]);

  // FIX 1: Removed console.log

  useEffect(() => { setZoom(1); }, [previewImageUrl, showImageModal]);

  const [instructionText, setInstructionText] = useState(ticketdetails?.instruction?.trim() || "");

  // FIX 2: Replaced separate solutionText + input/setInput mess with a single state

  const isWorkflowClosed = type === "Workflow" && Number(ticketdetails?.status?.id) === 6;

  const { templates } = useSelector((state) => state.messageTemplateDropdown);
  const quillRef = useRef(null);

  useEffect(() => {
    dispatch(loadMessageTemplateDropdown("solution"));
  }, [dispatch]);

  // FIX 3: handleTemplateChange now uses solutionText/setSolutionText correctly
  const handleTemplateChange = (e) => {
    const selectedId = Number(e.target.value);
    const selectedTemplate = templates?.find((t) => t.id === selectedId);
    if (selectedTemplate) {
      setFieldValue("solution.solution_text", selectedTemplate.template_message); // ← CHANGED
    }
  };

  // Sync when ticketdetails changes (e.g. on tab switch)
  useEffect(() => {
    setInstructionText(ticketdetails?.instruction?.trim() || "");
  }, [ticketdetails]);

  const getPreviewType = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext)) return "image";
    if (ext === "pdf") return "pdf";
    if (["mp4", "webm", "mov", "m4v"].includes(ext)) return "video";
    if (["mp3", "wav", "ogg"].includes(ext)) return "audio";
    if (["txt", "csv"].includes(ext)) return "text";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext)) return "office";
    return "unknown";
  };

  const getFileIcon = (fileName) => {
    const ext = fileName.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext)) return "far fa-image text-primary";
    if (ext === "pdf") return "far fa-file-pdf text-danger";
    if (["doc", "docx"].includes(ext)) return "far fa-file-word text-primary";
    if (["xls", "xlsx"].includes(ext)) return "far fa-file-excel text-success";
    if (["mp4", "webm", "mov", "avi", "mkv", "wmv", "mpeg", "mpg", "flv", "ogv", "3gp", "m4v"].includes(ext)) return "far fa-file-video text-warning";
    if (["mp3", "wav", "ogg"].includes(ext)) return "far fa-file-audio text-info";
    return "far fa-file text-secondary";
  };

  // FIX 4: Renamed inner `type` variable to `fileType` to avoid shadowing the prop
  const handleAttachmentClick = (file) => {
    const files = combinedAttachments;
    const index = files.findIndex((f) => f.id === file.id);
    setAttachments(files);
    setCurrentIndex(index);
    const fileType = getPreviewType(file.file_name);
    setPreviewType(fileType);
    setPreviewImageUrl(file.signed_url);
    setShowImageModal(true);
  };

  const forceDownload = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getSAPFromStoreName = (storeName) => {
    if (!storeName) return "";
    const parts = storeName.split(",");
    return parts.length > 1 ? parts[1].trim() : "";
  };
  
  const handleCopyAddress = () => {
    const address = ticketdetails?.store_address;
    if (!address) return;
    navigator.clipboard.writeText(address).then(() => {
      setAddressCopied(true);
      setTimeout(() => setAddressCopied(false), 2000);
    });
  };
  
  let store_phone = "12345678";
 
  return (
    <>
      <div className="px-0">
        {/* ---------- Location Section ---------- */}
        
          <Card className="mb-3 border-0">
            <Card.Body className="p-0">
              <Row className="g-2">
                <Col md={3}>
                  <Form.Group controlId="sap">
                    <Form.Label>
                      <strong>SAP</strong>
                    </Form.Label>
                    <i
                      className="fas fa-external-link-alt ms-2 location-link-icon"
                      title="Open Store Search"
                      onClick={() => {
                        const storeName =
                          type === "Workflow"
                            ? ticketdetails?.location?.store_name
                            : ticketdetails?.store_name;
                        const sap = getSAPFromStoreName(storeName);
                        if (sap) window.open(`/search-sap?sap=${sap}`, "_blank");
                      }}
                    />
                    {/* Store Visit */}
                    <span
                      className="ms-2 store-visit-link"
                      onClick={() => setShowStoreVisitModal(true)}
                      title="View Store Visits"
                    >
                      Store Visit
                    </span>

                    <Field
                      name="location.sap"
                      className="form-control"
                      type="text"
                      value={values.location.sap || "--"}
                      readOnly
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="district">
                    <Form.Label><strong>District</strong></Form.Label>
                    <a href={`/district/${type === "Workflow" ? ticketdetails?.location?.market_id : ticketdetails?.market_id}`} target="_blank" rel="noopener noreferrer" title="Open Employee District" className="ms-2">
                      <i className="fas fa-external-link-alt location-link-icon" ></i>
                    </a>
                    <Field name="location.district" className="form-control" type="text" value={values.location.district || "--"} readOnly />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="region">
                    <Form.Label><strong>Region</strong></Form.Label>
                    <a href={`/region/${type === "Workflow" ? ticketdetails?.location?.region_id : ticketdetails?.region_id}`} target="_blank" rel="noopener noreferrer" title="Open Employee Region" className="ms-2">
                      <i className="fas fa-external-link-alt location-link-icon" ></i>
                    </a>
                    <Field name="location.region" className="form-control" type="text" value={values.location.region || "--"} readOnly />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="company">
                    <Form.Label><strong>Company</strong></Form.Label>
                    <a href={`/company/${type === "Workflow" ? ticketdetails?.location?.company_id : ticketdetails?.company_id}`} target="_blank" rel="noopener noreferrer" title="Open Company" className="ms-2">
                      <i className="fas fa-external-link-alt location-link-icon" ></i>
                    </a>
                    <Field
                      name={type === "Workflow" ? "company" : "location.company"}
                      className="form-control"
                      type="text"
                      value={type === "Workflow" ? (values.company || "--") : (values.location?.company || "--")}
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>

            {/* ===== Store Address – visible only for group_id 14 & 19 ===== */}
                  {[14, 19].includes(Number(ticketdetails?.assigned_to_admin_group)) && (
                  <Row className="g-2 mt-1">

                    {/* Store Address */}
                    <Col md={8}>
                      <div className="d-flex align-items-center gap-2">
                        <div style={{ whiteSpace: "nowrap", minWidth: "fit-content", fontSize: "13px" }}>
                          <strong>Store Address</strong>
                        </div>
                        <div
                          className="form-control"
                          style={{
                            background: "#e9ecef",
                            cursor: "default",
                            fontSize: "13px",
                            color: ticketdetails?.store_address ? "inherit" : "#6c757d",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          {ticketdetails?.store_address || "No address on file"}

                          {/* Copy icon for address only */}
                          {ticketdetails?.store_address && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>{addressCopied ? "Copied!" : "Copy address"}</Tooltip>}
                            >
                              <i
                                className={addressCopied ? "fas fa-check" : "far fa-copy"}
                                style={{
                                  color: addressCopied ? "#28a745" : "#359acd",
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  marginLeft: "4px",
                                }}
                                onClick={handleCopyAddress}
                              />
                            </OverlayTrigger>
                          )}
                        </div>
                      </div>
                    </Col>

                    {/* Phone Number */}
                    <Col md={4}>
                      <div className="d-flex align-items-center gap-2">
                        <div style={{ whiteSpace: "nowrap", minWidth: "fit-content", fontSize: "13px" }}>
                          <strong>Phone</strong>
                        </div>
                        <div
                          className="form-control"
                          style={{
                            background: "#e9ecef",
                            cursor: "default",
                            fontSize: "13px",
                            color: ticketdetails?.phone_number ? "inherit" : "#6c757d",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          {ticketdetails?.phone_number ? (
                            <>
                              <i className="fas fa-phone" style={{ color: "#359acd", fontSize: "12px" }} />
                              <a
                                href={`webexteams://call?number=${ticketdetails.phone_number.replace(/[^\d]/g, "")}`}
                                style={{
                                  color: "#359acd",
                                  fontSize: "13px",
                                  textDecoration: "none",
                                }}
                                onMouseEnter={e => e.currentTarget.style.textDecoration = "underline"}
                                onMouseLeave={e => e.currentTarget.style.textDecoration = "none"}
                              >
                                {ticketdetails.phone_number}
                              </a>
                            </>
                          ) : (
                            "No phone on file"
                          )}
                        </div>
                      </div>
                    </Col>

                  </Row>
                )}
            </Card.Body>
          </Card>

        {/* Divider line */}
        <hr className="ticket-divider my-3" />

        {/* ---------- Ticket Details Section ---------- */}
        <Card className="border-0">
          <Card.Body className="p-0">
            <Row className="g-3">
              {/* Summary */}
              <Col md={12}>
                <Form.Group controlId="summary">
                  <Form.Label>
                    <strong>Subject</strong>
                  </Form.Label>
                  <Field
                    name="ticket.summary"
                    className="form-control"
                    placeholder="Enter ticket summary"
                    maxLength={50}
                    value={values.ticket.summary}
                    onChange={(e) => setFieldValue("ticket.summary", e.target.value)}
                    // FIX 6: Added explicit parentheses for clarity
                    disabled={isWorkflowClosed || (type === "Workflow" && !canEdit)}
                  />
                  <ErrorMessage name="ticket.summary" component="div" className="error-text" />
                </Form.Group>
              </Col>             

              {/* Description + Employee Search */}
            <Col md={12}>
              <Form.Group controlId="description">
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <Form.Label className="mb-0">
                    <strong>Description</strong>
                    <span className="error-text">*</span>
                  </Form.Label>

                  {/* Employee Search Pill */}
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <span style={{ fontSize: "12px", color: "#6c757d", whiteSpace: "nowrap" }}>
                    <i className="fas fa-search me-1" style={{ fontSize: "10px" }} />
                    Search employee:
                  </span>
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    background: "var(--color-background-secondary, #f8f9fa)",
                    border: "0.5px solid var(--color-border-tertiary, #dee2e6)",
                    borderRadius: "20px",
                    padding: "0 8px 0 12px",
                    height: "28px",
                    width: "260px",
                    gap: "4px",
                  }}>
                    <input
                      type="text"
                      value={empSearchValue}
                      onChange={(e) => setEmpSearchValue(e.target.value)}
                      style={{
                        flex: 1,
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        fontSize: "12px",
                        color: "inherit",
                        padding: 0,
                      }}
                      placeholder="Email, Emp ID or Name..."
                      onKeyDown={(e) => {
                        if (e.key !== "Enter") return;
                        e.preventDefault();
                        const val = empSearchValue.trim();
                        if (!val) return;
                        let field = "first_name";
                        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) field = "email_work";
                        else if (/^\d{5,7}$/.test(val)) field = "employee_id";
                        else if (/^[A-Z][a-z]+[A-Z0-9][a-zA-Z0-9]{1,8}$/.test(val)) field = "ntid";
                        window.open(`/employees?filter=${JSON.stringify({ [field]: { filterType: "text", type: "inArray", filter: val } })}`, "_blank");
                      }}
                    />
                    {empSearchValue && (
                      <button
                        type="button"
                        style={{
                          border: "none",
                          background: "none",
                          cursor: "pointer",
                          padding: "0 2px",
                          fontSize: "13px",
                          color: "#aaa",
                          lineHeight: 1,
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={() => setEmpSearchValue("")}
                      >
                        <i className="fas fa-times-circle" />
                      </button>
                    )}
                  </div>

                  {/* Orange external-link button — outside the gray bar */}
                  <button
                    type="button"
                    className="emp-search-btn"
                    onClick={() => {
                      const val = empSearchValue.trim();
                      if (!val) return;
                      let field = "first_name";
                      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) field = "email_work";
                      else if (/^\d{5,7}$/.test(val)) field = "employee_id";
                      else if (/^[A-Z][a-z]+[A-Z0-9][a-zA-Z0-9]{1,8}$/.test(val)) field = "ntid";
                      window.open(`/employees?filter=${JSON.stringify({ [field]: { filterType: "text", type: "inArray", filter: val } })}`, "_blank");
                    }}
                  >
                    <i className="fas fa-external-link-alt" style={{ color: "white", fontSize: "10px" }} />
                  </button>
                </div>
                </div>
                </div>

                <Field
                  as="textarea"
                  name="ticket.description"
                  className="form-control"
                  placeholder="Enter ticket description"
                  rows={12}
                  value={values.ticket.description}
                  onChange={(e) => setFieldValue("ticket.description", e.target.value)}
                  style={{ background: (type === "Workflow" && !canEdit) ? "rgb(233, 236, 239)" : "#fff" }}
                  disabled={isWorkflowClosed || (type === "Workflow" && !canEdit)}
                />
                <ErrorMessage name="ticket.description" component="div" className="error-text" />
              </Form.Group>
            </Col>

              {/* Instructions – only if instruction exists */}
              {instructionText && (
                <Col md={12} className="mt-3">
                  <Form.Group controlId="instructions">
                    <Form.Label>
                      <strong>Instructions</strong>
                    </Form.Label>
                    <Field
                      as="textarea"
                      name="workflow.instructions"
                      className="form-control"
                      placeholder="Enter workflow instructions"
                      rows={6}
                      value={instructionText}
                      onChange={(e) => {
                        setInstructionText(e.target.value);
                        setFieldValue("workflow.instructions", e.target.value);
                      }}
                      style={{ background: "#fff" }}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              )}

              {/* Solution – only for Workflow type */}
              {type === "Workflow" && (
                  <>
                    {/* Template Dropdown */}
                    <Col md={12} className="mt-3">
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Solution Template</Form.Label>
                        <Form.Select
                            size="sm"
                            value={selectedTemplateId}
                            onChange={(e) => {
                              setSelectedTemplateId(e.target.value);
                              handleTemplateChange(e);
                            }}
                            className="solution-template-select"
                          >
                            <option value="">Select Solution Template</option>
                            {templates?.map((template) => (
                              <option key={template.id} value={template.id}>
                                {template.template_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                    </Col>

                    {/* Solution Editor */}
                    <Col md={12}>
                      <Form.Group className="mb-2">
                        <Form.Label className="fw-semibold">Solution</Form.Label>
                        <ReactQuill
                          ref={quillRef}
                          value={values.solution?.solution_text || ""}
                          onChange={(val) => setFieldValue("solution.solution_text", val)}
                          modules={quillModules}
                          readOnly={!canEdit}
                          placeholder="Enter the solution..."
                          className="solution-editor"
                        />
                        {/* Validation error */}
                        <ErrorMessage
                          name="solution.solution_text"
                          component="div"
                          className="error-text"
                        />
                      </Form.Group>
                    </Col>
                  </>
                )}
              {/* ---------- Attachment Section ---------- */}
              <Col md={12}>
                <Form.Group controlId="attachments">
                  <Form.Label>
                    <strong>Attachment</strong>
                  </Form.Label>
                  {combinedAttachments.length > 0 ? (
                    <div className="d-flex flex-wrap gap-4">
                      {combinedAttachments.map((f) => {
                          const isDeletable = f.id != null && (f.message_id === null || f.message_id === undefined);

                          return (
                            <div key={f.id} className="d-flex align-items-center" style={{ gap: "8px", minWidth: "200px" }}>
                              <i className={`${getFileIcon(f.file_name)}`} style={{ fontSize: "18px" }}></i>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-start attachment-link"
                                onClick={() => handleAttachmentClick(f)}
                                style={{ fontSize: "14px", maxWidth: "140px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                              >
                                {f.file_name}
                              </button>

                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  forceDownload(f.signed_url, f.file_name);
                                }}
                                title="Download"
                              >
                                <i className="fas fa-download" style={{ color: "var(--color-primary-green)", fontSize: "16px" }}></i>
                              </a>

                              {isDeletable && (
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDeleteAttachment(f.id);
                                  }}
                                  title="Delete"
                                >
                                  {deletingId === f.id ? (
                                    <i className="fas fa-spinner fa-spin" style={{ color: "#dc3545", fontSize: "16px" }}></i>
                                  ) : (
                                    <i className="fas fa-trash" style={{ color: "#dc3545", fontSize: "16px" }}></i>
                                  )}
                                </a>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <p className="text-muted mb-0">No attachments</p>
                  )}
                </Form.Group>
              </Col>

              {/* NEW: uploader for adding attachments */}
                <Col md={12} className="mt-3">
                  <TicketAttachmentUpload ticketId={ticketdetails?.id} />
                </Col>

              {/* Attachment Preview Modal */}
              <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
                <Modal.Header closeButton className="d-flex align-items-center">
                  <Modal.Title className="m-0">Attachment Preview</Modal.Title>
                  <div className="flex-grow-1"></div>
                  <div className="icon-btn-group">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Zoom In</Tooltip>}>
                      <button className="btn btn-sm btn-outline-secondary icon-btn" onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}>
                        <i className="fas fa-plus-circle text-white"></i>
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Reset Zoom</Tooltip>}>
                      <button className="btn btn-sm btn-outline-secondary icon-btn" onClick={() => setZoom(1)}>
                        <i className="fas fa-undo-alt text-white"></i>
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Zoom Out</Tooltip>}>
                      <button className="btn btn-sm btn-outline-secondary icon-btn" onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}>
                        <i className="fas fa-minus-circle text-white"></i>
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Download</Tooltip>}>
                      <button
                        className="btn btn-sm btn-outline-secondary icon-btn"
                        onClick={() => {
                          const file = attachments[currentIndex];
                          forceDownload(file.signed_url, file.file_name);
                        }}
                      >
                        <i className="fas fa-download text-white"></i>
                      </button>
                    </OverlayTrigger>
                  </div>
                </Modal.Header>

                {/* Navigation */}
                <div className="d-flex justify-content-between align-items-center px-3 mt-2">
                  <DefaultButton
                    buttonClass="default-btn-color"
                    buttonTitle={<i className="fas fa-arrow-left"></i>}
                    actionBlock={() => {
                      const newIndex = currentIndex - 1;
                      setCurrentIndex(newIndex);
                      const f = attachments[newIndex];
                      setPreviewImageUrl(f.signed_url);
                      setPreviewType(getPreviewType(f.file_name));
                    }}
                    disabled={currentIndex === 0}
                  />
                  <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {currentIndex + 1} / {attachments.length}
                  </div>
                  <DefaultButton
                    buttonClass="default-btn-color"
                    buttonTitle={<i className="fas fa-arrow-right"></i>}
                    actionBlock={() => {
                      const newIndex = currentIndex + 1;
                      setCurrentIndex(newIndex);
                      const f = attachments[newIndex];
                      setPreviewImageUrl(f.signed_url);
                      setPreviewType(getPreviewType(f.file_name));
                    }}
                    disabled={currentIndex === attachments.length - 1}
                  />
                </div>

                <Modal.Body className="text-center" style={{ height: "500px", overflow: "auto" }}>
                  <div
  style={{
    transform: `scale(${zoom})`,
    transformOrigin: zoom > 1 ? "top left" : "center",   // ← CHANGED
    transition: "transform 0.2s ease",
    display: "inline-block",
    width: "100%",
  }}
>
                    {previewType === "image" && (
                      <img src={previewImageUrl} alt="Preview" style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "8px" }} />
                    )}
                    {previewType === "pdf" && (
                      <iframe src={previewImageUrl} title="PDF Preview" style={{ width: "100%", height: "80vh", border: "none" }} />
                    )}
                    {previewType === "video" && (
                      <video key={previewImageUrl} controls style={{ maxWidth: "100%", maxHeight: "80vh" }}>
                        <source
                          src={previewImageUrl}
                          type={
                            previewImageUrl.endsWith(".mov") ? "video/quicktime"
                            : previewImageUrl.endsWith(".webm") ? "video/webm"
                            : "video/mp4"
                          }
                        />
                        Your browser does not support this video format.
                      </video>
                    )}
                    {previewType === "audio" && (
                      <audio controls style={{ width: "100%" }}>
                        <source src={previewImageUrl} />
                      </audio>
                    )}
                    {previewType === "text" && (
                      <iframe src={previewImageUrl} style={{ width: "100%", height: "80vh", border: "none" }} />
                    )}
                    {previewType === "office" && (
                      <iframe
                        src={`https://docs.google.com/viewer?url=${encodeURIComponent(previewImageUrl)}&embedded=true`}
                        title="Office Preview"
                        style={{ width: "100%", height: "80vh", border: "none" }}
                      />
                    )}
                    {previewType === "unknown" && (
                      <p className="text-muted">Preview not available for this file. Click download instead.</p>
                    )}
                  </div>
                </Modal.Body>
              </Modal>
            </Row>
          </Card.Body>
        </Card>
      </div>
       {/* Store Visit Model */}
      <Modal
        show={showStoreVisitModal}
        onHide={() => setShowStoreVisitModal(false)}
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Store Visits — {ticketdetails?.store_name || ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <StoreCallVisitForm
            storeSap={
              type === "Workflow"
                ? ticketdetails?.location?.store_id   // ← the store's DB id, not sap string
                : ticketdetails?.store_id             // ← same here
            }
            storeName={ticketdetails?.store_name || ""}
            ticketNumber={ticketdetails?.ticket_number || ""}
            handleClose={() => setShowStoreVisitModal(false)}
            onSuccess={() => setShowStoreVisitModal(false)}
          />
        </Modal.Body>
      </Modal>
      {/* Delete Attachment Confirmation */}
        <Modalpopup
          show={showDeleteAttachmentModal}
          handleClose={() => {
            setShowDeleteAttachmentModal(false);
            setPendingDeleteFileId(null);
          }}
          actionTitle="Delete Attachment"
          size="sm"
        >
          <p>Are you sure you want to delete this attachment?</p>

          <div className="d-flex justify-content-end gap-2 mt-3">
            <DefaultButton
              buttonClass="btn btn-secondary"
              buttonTitle="Cancel"
              buttonType="button"
              actionBlock={() => {
                setShowDeleteAttachmentModal(false);
                setPendingDeleteFileId(null);
              }}
            />
            <DefaultButton
              buttonClass="btn btn-danger"
              buttonTitle="Delete"
              buttonType="button"
              actionBlock={confirmDeleteAttachment}
            />
          </div>
        </Modalpopup>
    </>
  );
};

export default TicketGeneral;